import { render, staticRenderFns } from "./MegaTable.vue?vue&type=template&id=280ec5cb&"
import script from "./MegaTable.vue?vue&type=script&lang=js&"
export * from "./MegaTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports